import React from 'react'
// import { StaticQuery, graphql, Link } from 'gatsby'
import { Link } from 'gatsby'
import styled from 'styled-components'
// import Img from 'gatsby-image'
import PhotoHeader from '../../../styles/main-photo-styles';
import PhotoContainer from '../../../styles/main-photo-container-styles';


class RestaurantsBlock extends React.Component {
    render() {
      // const { data } = this.props
      return(
        <MainContainer>
          <h2>Entertainment</h2>
          <p>Modern Moscow has numerous gastronomic options targeted at every budget. Officially there are more than <strong>11,000</strong> of restaurants in Moscow ranging from fast-food to high class cuisine. 
            Moscow has more than 140 McDonald’s restaurants that are spread around the city. The first McDonald’s restaurant was opened near Pushkinskaya metro station in 1990. It’s remarkable that it was visited by more than <strong>30,000</strong> people during its first day of work!</p>

            <p>Moscow is famous for its <strong>nightlife</strong>. There are many night clubs and bars that are open <strong>24 hours</strong>. Checkout our dedicated nightlife section that features the latest openings along with ratings and recommendations.</p>
          <PhotoContainer>
            <Link to={`/best-restaurants-moscow/`}>
                <picture><img src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559149701/Landing-MAIN/moscow-main-restaurants-960.jpg" alt="moscow russia"/></picture>     
            </Link>
            <PhotoHeader>
                <Link to={`/best-restaurants-moscow/`}>
                  <span>Here Are the Best</span>
                    <br></br>
                  <span>Restaurants in Moscow in 2019</span>
                </Link>
            </PhotoHeader>
          </PhotoContainer>
     
        </MainContainer>
      )
    }
}

const MainContainer = styled.div`
`;


export default RestaurantsBlock

// const mainPageRestaurants = graphql`
//   query mainPageRestaurants {
//     image1: file(relativePath: { eq: "main/moscow-main-restaurants-960.jpg" }) {
//       ...mainPageTopImage
//     }
//     # image2: file(relativePath: { eq: "banners/vanilia.jpg" }) {
//     #   ...squareImage
//     # }
// }
// `

// export const mainPageRestaurantsImage = graphql`
//   fragment mainPageRestaurantsImage on File {
//     childImageSharp {
//       fluid(maxWidth: 960, maxHeight: 400, quality: 100 ) {
//         ...GatsbyImageSharpFluid
//       }
//     }
//   }
// `
